// ponytail: web tsconfig includes WebWorker, so `navigator` is WorkerNavigator.
function browserClipboard() {
    return navigator.clipboard;
}
async function setContent(content, type) {
    const blob = new Blob([content], { type });
    const data = [new ClipboardItem({ [type]: blob })];
    await browserClipboard().write(data);
}
const clipboard = {
    setHTML(html) {
        return setContent(html, 'text/html');
    },
    setText(text) {
        return browserClipboard().writeText(text);
    },
};
export default clipboard;
